<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-current">
    <path
      d="M15.68 8.18c0-.56-.05-1.1-.14-1.62H8v3.06h4.3a3.68 3.68 0 0 1-1.6 2.41v2h2.59c1.51-1.4 2.39-3.45 2.39-5.85z"
    />
    <path
      d="M8 16c2.16 0 3.97-.72 5.29-1.94l-2.59-2a4.8 4.8 0 0 1-7.15-2.53H.9v2.07A8 8 0 0 0 8 16z"
    />
    <path
      d="M3.55 9.53a4.8 4.8 0 0 1 0-3.06V4.4H.9a8 8 0 0 0 0 7.2l2.65-2.07z"
    />
    <path
      d="M8 3.16c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 .9 4.4l2.65 2.07A4.77 4.77 0 0 1 8 3.16z"
    />
  </svg>
</template>

<script>
export default {};
</script>
